// Only these official player URLs can create frames. Never render provider HTML.
export function getOfficialEmbed(link) {
  if (link?.status !== 'ready' || !link.embedUrl) return null;
  try {
    const url = new URL(link.embedUrl);
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    // YouTube opens externally in WIW, including cached responses from older
    // API versions. Its WebView/owner playback restrictions are not a preview.
    if (link.provider === 'spotify' && url.hostname === 'open.spotify.com'
      && /^\/embed\/(track|album|playlist|artist|episode|show)\/[A-Za-z0-9]{22}$/.test(url.pathname)) {
      return { src: `${url.origin}${url.pathname}?theme=0`, height: 352 };
    }
    if (link.provider === 'appleMusic' && url.hostname === 'embed.music.apple.com'
      && /^\/[a-z]{2}\/(album|song|playlist)\/(?:[^/]+\/)?(?:\d+|pl\.[\w.-]+)\/?$/.test(url.pathname)) {
      const source = new URL(`${url.origin}${url.pathname}`);
      const track = url.searchParams.get('i');
      if (track && /^\d+$/.test(track)) source.searchParams.set('i', track);
      source.searchParams.set('theme', 'light');
      return { src: source.href, height: track || url.pathname.includes('/song/') ? 175 : 450 };
    }
    if (link.provider === 'soundcloud' && url.hostname === 'w.soundcloud.com' && /^\/player\/?$/.test(url.pathname)) {
      const target = new URL(url.searchParams.get('url'));
      if (target.protocol !== 'https:' || target.username || target.password || target.port
        || !['soundcloud.com', 'www.soundcloud.com', 'api.soundcloud.com'].includes(target.hostname)
        || !/^\/[\w-]+\/[\w/-]+\/?$/.test(target.pathname)) return null;
      const source = new URL('https://w.soundcloud.com/player/');
      source.searchParams.set('url', `${target.origin}${target.pathname}`);
      source.searchParams.set('auto_play', 'false');
      source.searchParams.set('single_active', 'true');
      source.searchParams.set('visual', 'false');
      source.searchParams.set('show_artwork', 'true');
      return { src: source.href, height: /\/(sets|playlists)\//.test(target.pathname) || link.kind === 'playlist' ? 450 : 166 };
    }
  } catch { /* Invalid or unsupported embeds remain ordinary validated links. */ }
  return null;
}
